import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import Icon from '../Icon';

const SortableItem = ({
    type,
    onReorder,
    index,
    children,
    styles = {},
}) => {
    const ref = useRef(null);

    const [{ handlerId }, drop] = useDrop({
        accept: type,
        hover: (item, monitor) => {
            if (onReorder) {
                const dragIndex = item.index;
                const hoverIndex = index;

                if (ref.current && dragIndex !== hoverIndex) {
                    const hoverBoundingRect = ref.current.getBoundingClientRect();
                    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
                    const clientOffset = monitor.getClientOffset();
                    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

                    const isDraggingDown = dragIndex < hoverIndex && hoverClientY > hoverMiddleY;
                    const isDraggingUp = dragIndex > hoverIndex && hoverClientY < hoverMiddleY;

                    if (isDraggingDown || isDraggingUp) {
                        onReorder(dragIndex, hoverIndex);
                        item.index = hoverIndex;
                    }
                }
            }
        },
        collect: (monitor) => ({
            handlerId: monitor.getHandlerId(),
        }),
    }, [type, onReorder]);

    const [{ isDragging }, drag] = useDrag({
        type,
        item: () => ({
            index,
        }),
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    }, [type]);

    drag(drop(ref));

    return (
        <div className={`${isDragging ? (styles.dragging || '') : (styles.default || '')}`}>
            <div
                ref={ref}
                className="me-2"
                style={{
                    cursor: 'move',
                }}
                data-handler-id={handlerId}
            >
                <Icon icon="OpenWith"></Icon>
            </div>
            {children}
        </div>

    );
};

export default SortableItem;